module.exports = "pegasus/assets/themelp1/coming_soon/100.png";